// Blogs — reserved space, to be populated later. Add objects with:
// { slug, tag, title, excerpt, img, date, read, body: [paragraphs] }
export const BLOGS = [];

// Case Studies. Body items: plain string = paragraph, "## " prefix = heading, "- " prefix = bullet.
export const CASES = [
  {
    slug: "school-website-45-to-10000",
    tag: "Education · Web Growth",
    title: "How We Helped a School Website Grow From 45 to 10,000 Monthly Visitors",
    excerpt:
      "A school website that existed as a formality became the community's daily destination — growing from 45 to roughly 10,000 monthly visitors in one year.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_branding-lab-8/artifacts/agi38giv_Gemini_Generated_Image_vixxxcvixxxcvixx.png",
    date: "One-year engagement",
    metrics: [
      ["220x", "Traffic growth"],
      ["10,000", "Monthly visitors"],
      ["+22,122%", "Growth in one year"],
    ],
    body: [
      "When we started working with this school, their website had a very basic structure. It existed, but it wasn't really doing anything for the school. There was no active promotion, no clear reason for parents or students to visit, and the traffic showed it — the site was getting only around 45 visitors a month.",
      "Over the course of one year, that changed. Monthly visitors grew to around 10,000, and more importantly, the website became something the school's community actually used on a regular basis.",
      "## Where We Started",
      "Like a lot of school websites, this one was more of a formality than a functioning part of the school's communication. It hadn't been actively promoted, the content wasn't organized around what parents and students were actually looking for, and there wasn't a strong reason for anyone to keep coming back once they'd visited once.",
      "## What We Did",
      "We didn't treat this as a simple \"get more traffic\" project. The goal was to make the website genuinely useful to the people it was meant for — parents and students — and let the traffic growth follow from that.",
      "A few things we focused on:",
      "- Restructuring the content so the website was organized around what visitors actually needed, instead of how the school internally saw its own information.",
      "- Redesigning the site to feel more student-friendly and more appealing to parents, with a stronger focus on engagement rather than just displaying information.",
      "- Adding a photo and video gallery, including a section for downloading images and links to YouTube videos from school events.",
      "- Redirecting all outside communication back to the website — announcements, updates, and event information all pointed people to the site instead of living somewhere else.",
      "- Using the gallery as a reason to return — event photos and videos were made available specifically through the website, so if a parent or student wanted to download pictures from a school event, they had to visit the site to get them.",
      "- Running targeted digital ads and using pop-ups to help more people discover the website in the first place.",
      "## Why This Worked",
      "A lot of website promotion stops at getting people to visit once. What made the difference here was giving people an ongoing reason to come back. Every school event — a sports day, an annual function, a cultural program — created a natural reason for parents and students to return to the website afterward, to find and download their photos and videos. The ads and pop-ups brought people in the first time; the content itself is what kept bringing them back.",
      "## The Result",
      "Over one year, the website's monthly traffic grew from 45 visitors to approximately 10,000 — a change driven not by one single tactic, but by turning the website into a place people actually needed to visit.",
      "## What This Shows",
      "A website doesn't grow just because you promote it more. It grows when people have a real reason to use it. For schools especially, giving parents and students something ongoing and useful — like access to memories from school events — can do more for engagement than promotion alone.",
    ],
  },
];

export const CONCEPTS = [
  {
    slug: "solace-retreats",
    tag: "Concept — Hospitality",
    title: "Solace Retreats",
    desc: "A wellness resort identity built around quiet, not luxury cliché.",
    img: "https://images.unsplash.com/photo-1733459065643-da5d3db9f7a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "meridian-academy",
    tag: "Concept — Education",
    title: "Meridian Academy",
    desc: "Repositioning a school as a launchpad, not an institution.",
    img: "https://images.unsplash.com/photo-1614595737766-4d7e1fd1406f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "ember-and-co",
    tag: "Concept — F&B",
    title: "Ember & Co",
    desc: "A restaurant brand built around fire, not another rustic-chic cafe.",
    img: "https://images.unsplash.com/photo-1662982692115-743f9e716b98?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];
